import { useEffect } from "react";

const COOKIE_KEY = "cookie-consent";
const GA_ID = "G-K94YZMJ7H0"; // sostituisci con il tuo ID GA4

export default function GoogleAnalytics() {
    useEffect(() => {
        const loadAnalytics = () => {
            const savedConsent = localStorage.getItem(COOKIE_KEY);

            if (!savedConsent) return;

            try {
                const preferences = JSON.parse(savedConsent);

                if (!preferences.analytics) return;

                if (window.gtag) return;

                const script = document.createElement("script");
                script.async = true;
                script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;

                document.head.appendChild(script);

                window.dataLayer = window.dataLayer || [];

                window.gtag = function () {
                    window.dataLayer.push(arguments);
                };

                window.gtag("js", new Date());
                window.gtag("config", GA_ID);
            } catch (error) {
                console.error("Errore caricamento Google Analytics:", error);
            }
        };

        loadAnalytics();

        const handleConsentChange = () => {
            loadAnalytics();
        };

        window.addEventListener(
            "cookieconsent:changed",
            handleConsentChange
        );

        return () => {
            window.removeEventListener(
                "cookieconsent:changed",
                handleConsentChange
            );
        };
    }, []);

    return null;
}